import type { RootState } from '../store'
import { FeatureFlags } from '../slices/uiSlice'

// Feature flag selectors
export const selectFeatureFlags = (state: RootState) => state.ui.featureFlags

export const selectIsGamerEnabled = (state: RootState) => state.ui.featureFlags.enableGamer

export const selectIsFacilitatorEnabled = (state: RootState) => state.ui.featureFlags.enableFacilitator

export const selectIsLanguageSwitcherEnabled = (state: RootState) => state.ui.featureFlags.enableLanguageSwitcher

export const selectIsLatestSessionFeedbackEnabled = (state: RootState) =>
  state.ui.featureFlags.enableLatestSessionFeedback

export const selectIsGenerateReportsEnabled = (state: RootState) => state.ui.featureFlags.enableGenerateReports

export const selectIsExperimentalTeamFeedbackEnabled = (state: RootState) =>
  state.ui.featureFlags.enableExperimentalTeamFeedback

export const selectIsAchievementsEnabled = (state: RootState) => state.ui.featureFlags.enableAchievements

// Generic selector for any feature flag
export const selectFeatureFlag = (flagName: keyof FeatureFlags) => (state: RootState) => state.ui.featureFlags[flagName]
